/** AUTO GENERATED FROM "node ./src/utils/build-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg
        viewBox="0 0 25.27 17.6"
        width="25.27"
        height="17.6"
        fill="currentColor"
        className={classNames('nmx-icon', className)}
        ref={svgRef}
        {...otherProps}>
        <path
          d="M10,14.42,3.55,8C2.25,6.62.33,8.7,1.69,10L9,17.34a1.32,1.32,0,0,0,1.85,0L25.54,3.05C26.86,1.8,25-.2,23.72,1Z"
          transform="translate(-0.97 -0.38)"
          stroke="#0e497b"
          className="icon-fill"
          strokeWidth="0.5px"/>
      </svg>

    );
  }
}

Icon.displayName = 'CheckmarkBoldIcon';

export default Icon;
